module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagef"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f007-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2n"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('p', {
    staticClass: "h2c"
  }, [_vm._v("welcome to your field guide")]), _vm._v(" "), _c('p', {
    staticClass: "imagef1"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ccenter"
  }, [_c('em', [_vm._v("Trust yourself. Then you will know how to live.")])]), _vm._v(" "), _c('p', {
    staticClass: "ccenter1"
  }, [_vm._v("—Johann Wolfgang von Goethe")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("People swear up and down that I’m an extrovert.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This drives me nuts! I deny these accusations adamantly and then am subjected to a laundry list of supposed examples as to why I am mistaken. “But you’re high energy! You give presentations for a living! You wrote a networking book, for crying out loud!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blah, blah, blah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("These people have no idea what it really means to be an introvert. They assume being an introvert "), _c('em', [_vm._v("by definition")]), _vm._v(" implies that one cannot be a lively, confident person or astute networker.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Together, we will dispute, disprove, and knock upside the head these assumptions.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "underlev"
  }, [_vm._v("Your Author and Tour Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As we embark through the uncharted terrain of networking for people who hate networking, you want to be certain you are in capable hands. Why am I qualified to lead you on this journey?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First of all, despite protests from well-intentioned, ill-advised naysayers, I am an off-the-chart introvert. I am also nearly always overwhelmed and decidedly underconnected. My idea of a good time is hanging out alone. I regularly have conversations with people in my head that I think actually took place. I need time to process ideas thoroughly before responding—or I get myself into trouble. The idea of a free-floating happy hour propels me into free-floating anxiety. A cacophony of external stimuli doesn’t excite me; it drives me away. I easily and naturally pick up on nonverbal cues many others miss. I prefer a few deep relationships to a large group of friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As you’ve undoubtedly noted, none of these preferences are linked to energy level, a propensity for public speaking, or professional achievement. That’s because these attributes are not related to introversion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let’s have some fun. I will present examples of traits that, to the untrained eye, may seem extrovert-centric, but with a bit of analysis emerge as introvert-friendly.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('em', [_vm._v("I am Type A and move fast.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quack “experts” profess that introverts are somehow slower paced than extroverts. This is baloney. Introverts are as likely as the next "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("person to be highly active. Introversion ≠ lethargy! In fact, due to a penchant for heightened concentration and attentiveness, introverts are well positioned to be dynamos.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('em', [_vm._v("I am comfortable in front of a room.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whoa! This combats most introvert stereotypes head on. Yet introverts are entirely capable of being public speakers. In fact, introverts prefer clearly defined roles, so many are more at ease in front of a group than roaming aimlessly through a cocktail party.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('em', [_vm._v("I love networking.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Herein lies the book’s focus. This was not always the case for me. I discovered some wonderful techniques that turned the world of networking upside down—or shall I say right side up? You, too, can gain insights that allow you to excel at networking. You can be a networking superstar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seem impossible? I am here to tell you it is not.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "underlev"
  }, [_vm._v("A Brief History of the Introvert")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many readers of this book are introverts. Many have been taught through cultural cues that introversion is a problem, a deficit, something unfortunate to hide or overcome.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From a young age, introverts receive the message that it is an extrovert’s world. "), _c('em', [_vm._v("Go play with others. Join in on the game. Class participation is part of your grade.")]), _vm._v(" Kids who withdraw around crowds are labeled as antisocial rather than applauded for being self-regulating.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Introversion is innate, and preferences are observable early on. As a kid, I asked for games to play alone—a request that could prompt some parents to conduct a thorough psychological examination. As a parent now myself, I recognized traits indicating an introverted preference in one of my sons from the age of three.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('strong', [_vm._v("THE BIG THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Introverts are "), _c('em', [_vm._v("reflective")]), _vm._v(", "), _c('em', [_vm._v("focused,")]), _vm._v(" and "), _c('em', [_vm._v("self-reliant")]), _vm._v(". These characteristics lead to the following key distinctions between introverts and extroverts:")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdr"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Introverts think to talk.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Reflective")])]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Extroverts talk to think.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Verbal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdtbr"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Introverts go deep.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Focused")])]), _vm._v(" "), _c('td', {
    staticClass: "tdtbl"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Extroverts go wide.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Expansive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdtr"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Introverts energize alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Self-reliant")])]), _vm._v(" "), _c('td', {
    staticClass: "tdtl"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Extroverts energize with others.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Social")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why not indulge yourself and utilize all three characteristics at once? Take some time to ponder these traits ("), _c('em', [_vm._v("reflective")]), _vm._v("), in depth ("), _c('em', [_vm._v("focused")]), _vm._v("), while alone ("), _c('em', [_vm._v("self-reliant")]), _vm._v("). I’ll wait here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regardless of temperament, linking your strengths to customized methods puts you in a primo position to network away. Introverts, extroverts, and centroverts (definition ahead!) can all benefit from this field guide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Did I mention that I am psychic? I sense you are curious where you land in all this. Right this way …")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f3d3b39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch1.vue
// module id = 84
// module chunks = 0